const en = {
  "nav.expos": "Expos",
  "nav.map": "Map",
  "nav.ai": "AI",
  "nav.notes": "Notes",
  "nav.profile": "Profile",

  "splash.tagline": "Navigate smarter. Connect better.",
  "splash.tag.ai": "AI-Powered",
  "splash.tag.realtime": "Real-Time",
  "splash.tag.nav": "Smart Navigation",
  "splash.stat.expos": "Expos",
  "splash.stat.booths": "Booths",
  "splash.stat.accuracy": "Accuracy",
  "splash.trusted": "Trusted by 45,000+ professionals worldwide",
  "splash.btn.enter": "Enter App",
  "splash.btn.demo": "Explore Demo",

  "expoSelect.title": "Discover Expos",
  "expoSelect.subtitle.events": "events available",
  "expoSelect.search.placeholder": "Search expos, cities, categories...",
  "expoSelect.filter.all": "All",
  "expoSelect.filter.active": "Active",
  "expoSelect.filter.upcoming": "Upcoming",
  "expoSelect.filter.past": "Past",
  "expoSelect.featured": "Featured • Live Now",
  "expoSelect.allEvents": "All Events",
  "expoSelect.live": "LIVE",
  "expoSelect.booths": "Booths",
  "expoSelect.attendees": "Attendees",
  "expoSelect.halls": "Halls",
  "expoSelect.enter": "Enter",
  "expoSelect.noResults": "No expos match your search",
  "status.active": "Active",
  "status.upcoming": "Upcoming",
  "status.past": "Past",

  "map.title": "Expo Map",
  "map.subtitle": "World Tech Summit 2026 • Dubai",
  "map.coverage": "Expo Coverage",
  "map.legend.visited": "Visited",
  "map.legend.recommended": "Recommended",
  "map.legend.important": "Important",
  "map.legend.nonsponsored": "Non-sponsored",
  "map.entrance": "ENTRANCE",
  "map.stat.visited": "Visited",
  "map.stat.suggested": "Suggested",
  "map.stat.total": "Total",

  "booth.score": "AI Match Score",
  "booth.contact": "Contact",
  "booth.markVisited": "Mark Visited",
  "booth.visited": "Visited",
  "booth.markImportant": "Mark Important",
  "booth.important": "Important",
  "booth.whyAI": "Why AI?",
  "booth.aiReasoning": "AI Reasoning",
  "booth.quickNote": "Quick Note",
  "booth.notePlaceholder": "Add a note about this booth...",
  "booth.saveNote": "Save Note",
  "booth.noteSaved": "✓ Note Saved!",
  "booth.limitedInfo": "Full info available for sponsored booths",
  "booth.limitedAI": "Upgrade to see AI insights for this booth.",
  "sponsor.platinum": "✦ Platinum Sponsor",
  "sponsor.gold": "★ Gold Sponsor",
  "sponsor.standard": "Standard",
  "sponsor.none": "Non-sponsored",

  "ai.title": "AI Suggestions",
  "ai.subtitle": "Personalized for your profile • Updated live",
  "ai.active": "ExpoFlow AI is active",
  "ai.analyzing": "Analyzing 420 booths • Matching your interests",
  "ai.mustVisit": "Must Visit",
  "ai.nearby": "Nearby Opportunities",
  "ai.notVisited": "Not Yet Visited",
  "ai.stat.mustVisit": "Must Visit",
  "ai.stat.nearby": "Nearby",
  "ai.stat.unexplored": "Unexplored",
  "ai.score": "score",
  "ai.allDone": "You've explored everything!",
  "ai.allDoneDesc": "All recommended booths have been visited.",

  "progress.title": "Progress & Coverage",
  "progress.subtitle": "World Tech Summit 2026 • Your exploration report",
  "progress.explored": "Explored",
  "progress.coverage": "Expo Coverage",
  "progress.visitedOf": "visited out of total booths",
  "progress.stat.visited": "Visited",
  "progress.stat.important": "Important",
  "progress.stat.remaining": "Remaining",
  "progress.byHall": "By Hall",
  "progress.missedTitle": "Important Booths Not Visited Yet",
  "progress.passedTitle": "Booths You Passed Before",
  "progress.noVisited": "No visited booths yet. Start exploring!",
  "progress.analytics": "Analytics",
  "progress.time": "Time at Expo",
  "progress.distance": "Distance Walked",
  "progress.connections": "Connections Made",
  "progress.notes": "Notes Taken",
  "progress.backToMap": "Back to Map",

  "notes.title": "Meeting Notes",
  "notes.subtitle": "company records tracked",
  "notes.add": "Add",
  "notes.filter.all": "All",
  "notes.status.visited": "Visited",
  "notes.status.followup": "Follow-up",
  "notes.status.interested": "Interested",
  "notes.status.notRelevant": "Not Relevant",
  "notes.updateStatus": "Update Status",
  "notes.editNote": "Edit Note",
  "notes.share": "Share",
  "notes.noNotes": "No notes here",
  "notes.noNotesDesc": "Visit booths and take notes to track your meetings",
  "notes.save": "Save",
  "notes.cancel": "Cancel",

  "profile.title": "Profile & Settings",
  "profile.edit": "Edit",
  "profile.jobTitle": "VP of Technology • InnovateTech GmbH",
  "profile.proMember": "Pro Member",
  "profile.theme": "App Theme",
  "profile.theme.dark": "Dark Tech",
  "profile.theme.light": "Premium Light",
  "profile.industry": "Industry Focus",
  "profile.industry.selected": "selected",
  "profile.interests": "Interests & Goals",
  "profile.notifications": "Notifications",
  "profile.notif.ai": "AI Suggestions",
  "profile.notif.ai.desc": "Get personalized booth recommendations",
  "profile.notif.booth": "Booth Updates",
  "profile.notif.booth.desc": "Real-time alerts for saved booths",
  "profile.notif.reminders": "Meeting Reminders",
  "profile.notif.reminders.desc": "Upcoming meeting and follow-up alerts",
  "profile.notif.promotions": "Promotions",
  "profile.notif.promotions.desc": "Expo deals and sponsor offers",
  "profile.export": "Export My Data",
  "profile.export.desc": "Download notes & contacts",
  "profile.privacy": "Privacy Settings",
  "profile.privacy.desc": "Data usage & visibility",
  "profile.help": "Help & Support",
  "profile.help.desc": "FAQ and contact",
  "profile.about": "About ExpoFlow AI",
  "profile.about.desc": "Version 2.4.1",
  "profile.signout": "Sign Out",
  "profile.footer": "ExpoFlow AI • v2.4.1 • Built for expo professionals",
  "profile.language": "Language",
  "lang.tr": "Türkçe",
  "lang.de": "Deutsch",
  "lang.en": "English",
};

export default en;
